import { render, staticRenderFns } from "./InsumosVal.vue?vue&type=template&id=57b704ae&"
import script from "./InsumosVal.vue?vue&type=script&lang=js&"
export * from "./InsumosVal.vue?vue&type=script&lang=js&"
import style0 from "./InsumosVal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports